import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../propTypes';

const CustomToggle = ({ children, onClick }, ref) => (
    <div
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
);

CustomToggle.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.object,
};

CustomToggle.defaultProps = {
    onClick: noop,
    children: {},
};

export default React.forwardRef(CustomToggle);
